<script setup lang="ts">
const props = defineProps<{
  isWorking: boolean
  label?: string
  startedAt?: number
}>()

const { t } = useI18n()
const { elapsed } = useDocueAgentActivityDuration(() => props)

const summary = computed(() => props.isWorking
  ? props.label ?? t('docueAgent.thinking')
  : t('docueAgent.completed'),
)
</script>

<template>
  <div
    class="flex min-h-11 w-full items-center gap-2 py-0.5 text-neutral-500 md:min-h-0"
  >
    <UiSpinner
      v-if="isWorking"
      class="size-3.5 shrink-0"
    />
    <UiIcon
      v-else-if="!isWorking"
      name="docue:check"
      class="size-3.5 shrink-0"
      aria-hidden="true"
    />
    <span
      class="min-w-0 flex-1 truncate text-sm"
      aria-live="polite"
    >
      <Transition
        name="docue-agent-activity"
        mode="out-in"
      >
        <span :key="isWorking ? (label ?? 'thinking') : 'completed'">
          {{ summary }}
        </span>
      </Transition>
    </span>
    <span
      v-if="isWorking && elapsed"
      class="shrink-0 text-xs tabular-nums text-neutral-400"
    >
      {{ elapsed }}
    </span>
  </div>
</template>

<style scoped>
.docue-agent-activity-enter-active,
.docue-agent-activity-leave-active {
  transition:
    opacity 150ms ease,
    transform 150ms ease;
}

.docue-agent-activity-enter-from {
  opacity: 0;
  transform: translateY(0.25rem);
}

.docue-agent-activity-leave-to {
  opacity: 0;
  transform: translateY(-0.25rem);
}

@media (prefers-reduced-motion: reduce) {
  .docue-agent-activity-enter-active,
  .docue-agent-activity-leave-active {
    transition: none;
  }
}
</style>
